module.exports = __webpack_public_path__ + "img/collection-weddingRingsStackingRings@2x.459ce17.jpg";